import { isNil, isEmpty } from "lodash";

export default array => !isNil(array) && !isEmpty(array);
